import { Box, Divider, Grid, Link, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { imagesList } from "../../constants";
import { primary } from "../../constants/theme";
import { lendingPartnersInfo } from "../../constants/finance";

const lendingPartnersList = [
  // {
  //   imgUrl: imagesList.ghanaBhansali,
  //   name: "Ghalla Bhansali’s financial services",
  //   website: "https://www.ghallabhansali.com/",
  // },
  {
    imgUrl: imagesList.urgoCapitals,
    name: "U GRO Capital",
    website: "https://ugrocapital.com/",
    redressalPolicy: lendingPartnersInfo?.ugroCapital?.redressalPolicy,
    fairPracticesCode: lendingPartnersInfo?.ugroCapital?.fairPracticesCode,
    aum:'₹ 36.72 cr',
  },
  {
    imgUrl: imagesList?.shivalik,
    name: "Shivalik Small Finance Bank",
    website: "https://shivalikbank.com/",
    redressalPolicy: lendingPartnersInfo?.shivalik?.redressalPolicy,
    aum:'₹ 156.76 cr',
  },
  {
    imgUrl: imagesList?.idfc,
    name: "IDFC First Bank",
    website: "https://www.idfcfirstbank.com/",
  },
  // {
  //   imgUrl: imagesList?.arthmate,
  //   name: "Arthmate",
  //   website: "https://arthmate.com/",
  // },
  {
    imgUrl: imagesList?.dmiFinance,
    name: "DMI Finance",
    website: "https://www.dmifinance.in/",
    privacyPolicy: "https://www.dmifinance.in/privacy-policy.php",
    redressalPolicy: lendingPartnersInfo?.dmiFinance?.redressalPolicy,
    aum:'₹ 77.98 cr',
  },
  {
    imgUrl: imagesList?.vcpl,
    name: "Vivriti Capital Limited",
    website: "https://www.vivriticapital.com/index.html",
    privacyPolicy: "https://www.vivriticapital.com/assets/files/privacy-policy/VCL-IT-ISP-13%20Data%20privacy%20policy%20V%203.0.pdf",
    redressalMail: "grievanceredressal@vivriticapital.com",
    aum:'₹ 157.88 cr',

  }
];

const portfolioDetailsList = [
  { lender: "Lender 1", aum: "1,654,600,000", lienMarkFd: "0" },
  { lender: "Lender 2", aum: "1,513,700,000", lienMarkFd: "0" },
  { lender: "Lender 3", aum: "1,212,700,000", lienMarkFd: "0" },
  { lender: "Lender 4", aum: "314,500,000", lienMarkFd: "0" },
  { lender: "Lender 5", aum: "64,300,000", lienMarkFd: "0" },
  { lender: "Lender 6", aum: "57,300,000", lienMarkFd: "0" },
  { lender: "Lender 7", aum: "46,600,000", lienMarkFd: "0" },
  { lender: "Lender 8", aum: "39,400,000", lienMarkFd: "0" },
  { lender: "Lender 9", aum: "11,700,000", lienMarkFd: "0" },
  { lender: "Lender 10", aum: "800,000", lienMarkFd: "0" },
];

const formatInCr = (valueStr) => {
  const num = parseInt(String(valueStr).replace(/,/g, ""), 10);
  if (Number.isNaN(num)) return valueStr;
  return `${(num / 1e7).toFixed(2)} cr`;
};

const CustomLendingPartners = styled(Box)(({ theme }) => ({
  ".layout": {
    justifyContent: "flex-start",
    textAlign: "left",
    margin: "4% 4% 4% 4%",
  },
  ".title": {
    fontSize: "34px",
    fontWeight: "600",
    marginBottom: "20px",
    textAlign: "center",
  },

  ".subtitle": {
    fontSize: "18px",
  },

  ".img-css": {
    width: "200px",
    maxWidth: "100%",
    objectFit: "contain",
  },

  ".logo-wrap": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: "60px",
  },

  ".grid-css": {
    display: "flex",
    textAlign: "left",
    justifyContent: "flex-start",
    alignItems: "stretch",
  },

  ".grid-center": {
    overflow: "hidden",
  },

  ".divider-wrap": {
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
  },

  ".partner-card": {
    padding: theme.spacing(2, 2.5),
    borderRadius: 8,
    border: "1px solid",
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.grey[50],
  },

  ".details-block .subtitle": {
    marginBottom: theme.spacing(0.5),
  },

  ".portfolio-section": {
    marginTop: theme.spacing(6),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  ".portfolio-table-wrap": {
    marginTop: theme.spacing(2),
    maxWidth: 560,
    width: "100%",
    borderRadius: 8,
    border: "1px solid",
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.grey[50],
    boxShadow: "none",
    overflow: "hidden",
  },

  ".portfolio-table": {
    "& th, & td": {
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1, 1.5),
      fontSize: "0.9rem",
    },
    "& th": {
      fontWeight: 600,
      backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
    },
    "& tbody tr:last-child td": {
      borderBottom: "none",
    },
  },

  [theme.breakpoints.down("md")]: {
    ".layout": {
      justifyContent: "flex-start",
      textAlign: "left",
      margin: "4%",
    },
    ".title": {
      fontSize: "18px",
      marginBottom: "10px",
    },

    ".subtitle": {
      fontSize: "14px",
    },
    ".img-css": {
      width: "120px",
    },
  },

  [theme.breakpoints.down("sm")]: {
    ".subtitle": {
      fontSize: "12px",
    },
    ".img-css": {
      width: "100px",
    },
  },
}));

export const LendingPartnersDetails = () => {
  return (
    <CustomLendingPartners>
      <Box className="layout">
        <Typography variant="h1" className="title">
          Lending Partners
        </Typography>

        <Grid container spacing={3} justifyContent="flex-start">
          {lendingPartnersList.map((res, index) => {
            return (
              <Grid item xs={12} key={index}>
                <Grid container className="grid-css partner-card">
                  <Grid item xs={12} sm={3} className="grid-center logo-wrap">
                    <LazyLoadImage src={res.imgUrl} className="img-css" alt={res?.name} />
                  </Grid>
                  <Grid item xs={12} sm={1} className="divider-wrap">
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ borderRightWidth: 3, borderColor: primary?.main }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={7} className="grid-center">
                    <Box className="details-block">
                      <Typography className="subtitle">
                        Lender : <strong>{res.name}</strong>
                      </Typography>
                      <Typography className="subtitle">
                        Details :
                        <strong>
                          <Link href={res.website} target="_blank"> {res.website}</Link>
                        </strong>
                      </Typography>
                      {res.fairPracticesCode && (
                        <Typography className="subtitle">
                          Fair Practices Code :
                          <strong>
                            <Link href={res.fairPracticesCode} target="_blank"> {res.fairPracticesCode}</Link>
                          </strong>
                        </Typography>
                      )}
                      {res.privacyPolicy && (
                        <Typography className="subtitle">
                          Privacy Policy :
                          <strong>
                            <Link href={res.privacyPolicy} target="_blank">
                              {"privacy/policy"}
                            </Link>
                          </strong>
                        </Typography>
                      )}
                      {res.redressalPolicy && (
                        <Typography className="subtitle">
                          Grievance Redressal Mechanism :
                          <strong>
                            <Link href={res.redressalPolicy} target="_blank">
                              {"redressal_mechanism/policy"}
                            </Link>
                          </strong>
                        </Typography>
                      )}
                      {res.redressalMail && (
                        <Typography className="subtitle">
                          Grievance Redressal Mechanism :
                          <strong>
                            <Link href={`mailto:${res.redressalMail}`}>
                              {res.redressalMail}
                            </Link>
                          </strong>
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>

        <Box className="portfolio-section">
          <Typography variant="h1" className="title">
            DLG Disclosure
          </Typography>
          <TableContainer component={Paper} className="portfolio-table-wrap" sx={{ overflowX: "auto" }}>
            <Table className="portfolio-table" size="small" aria-label="Portfolio Details">
              <TableHead>
                <TableRow>
                  <TableCell>NBFC</TableCell>
                  <TableCell align="right">AUM (as of Apr&apos;26) (₹)</TableCell>
                  {/* <TableCell align="right">DLG (₹)</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {portfolioDetailsList.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      {row.lender}
                    </TableCell>
                    <TableCell align="right">{formatInCr(row.aum)}</TableCell>
                    {/* <TableCell align="right">{formatInCr(row.lienMarkFd)}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </CustomLendingPartners>
  );
};
